export const MULTI_AGENT_ENDPOINTS = {
    GET_ALL: '/multi-agent',
    CREATE: '/multi-agent/create',
    GET_BY_ID: (id: string) => `/multi-agent/${id}`,
    UPDATE: (id: string) => `/multi-agent/${id}`,
    DELETE: (id: string) => `/multi-agent/${id}`,
} as const;
